import * as bootstrap from 'bootstrap'
import * as _ from 'lodash'
import 'twitter-bootstrap-wizard/jquery.bootstrap.wizard.min.js'
import 'select2'


const meta = 'new-accounts'
window[`fnc_${meta}`] = initNewAccountPage

document.addEventListener("loadPage", () => {
    const evMeta = document.querySelector('meta[name="eventListener"]')
    if (evMeta !== null && evMeta['content'] === meta) {
        document.addEventListener("appReady", () => {
            if (DEBUG) console.log((`Initializing ${meta} page`))
            window[`fnc_${meta}`]()
        })
    }
})

function initNewAccountPage() {
    let data = []

    for (const [key, value] of Object.entries(globals.vars.currencies)) {
        data.push({
            id: key,
            text: `${key} - ${value}`
        })
    }

    $('#new-online-account-btn').off().on('click', function(e) {
        const unlockEvent = new Event("bankSelectorUnlocked")
        document.querySelector("#bank-selector-modal").dispatchEvent(unlockEvent)
    })


    $('.new-account-currency-select').select2({
        tags: false,
        dropdownParent: $("#local-account-modal"),
        data: data
    })

    $('.new-account-currency-select').on('change', () => {
        $('#currency-label').text( $('.new-account-currency-select').val().toString() )
    })

    $('.new-account-type-select').select2({
        tags: true,
        dropdownParent: $("#local-account-modal")
    })

    $('#inputName').on('blur', () => {
        if ($('#inputName').val() == '')
            $('#inputName').focus()
    })

    $("#local-account-modal").on('show.bs.modal', function (e) {
        $('#inputName').val('')
        $('#inputInstitutionId').val('')
        $('#inputSubtitle').val('')
        $('#inputBalance').val('')
        $('.new-account-currency-select').val('EUR')
        $('.new-account-currency-select').trigger('change')
        $('.new-account-type-select').val('0')
        $('.new-account-type-select').trigger('change')
        $('#evaluated').prop('checked', true)

    })

    $("#local-account-modal").on('shown.bs.modal', function (e) {
        $('#inputName').focus()
    })

    $('.bank-select-offline').off().on('click', function(e) {
        const lockEvent = new Event("bankSelectorLocked")
        document.querySelector("#bank-selector-modal").dispatchEvent(lockEvent)

        document.addEventListener('selectedInstitutionId', function callback(e) {
            const institution_id = e['detail']['selectedInstitutionId']

            document.removeEventListener('selectedInstitutionId', callback)

            var myModal2 = new bootstrap.Modal(document.getElementById('local-account-modal'), {})
            myModal2.show()
            
            $('#inputInstitutionId').val(institution_id)
        })
    })

    $('#new-account-form').on('submit', () => {
        const params = {
            name: $('#inputName').val(),
            iban: $('#inputSubtitle').val(),
            institution_id: $('#inputInstitutionId').val(),
            currency: $('.new-account-currency-select').val(),
            type: $('.new-account-type-select').select2('data')[0].text,
            balance: $('#inputAccountBalance').val(),
            statistic: $('#evaluated').prop('checked'),
            _csrf: $("meta[name=_csrf]").attr("content")
        }

        $.ajax({
            url: '/json/accounts/create',
            type: 'POST',
            data: params,
        
            success: function(req) {
                if (typeof req['error'] !== "undefined") {
                    console.log(req)
                } else {
                    if (DEBUG) console.log(req)

                   window.location.href = '/accounts'
                }
            },
            error: function( req, status, err ) {
                if (req.responseJSON && req.responseJSON.error == "invalid csrf token") {
                    console.log(req.responseJSON)
                } else {
                    console.log( req, status, err )
                    console.log('Error', req.responseText)
                }                   
            },
            cache: false
        })

        return false
    })

}


